import Countries from '@/utils/countries'

// TODO: Move this to utils/countries
export const countryCodeToName = (code: string | null): string | undefined =>
  Countries.find(country => country.code === code)?.name

export function isNotNull<T>(a: T | null): a is T {
  return a !== null
}
export function isNotNullOrUndefined<T>(a: T | undefined | null): a is T {
  return a != null
}

export const noOp = (): void => {
  /* No op */
}

export function getArticleForWord(word: string): string {
  return ['a', 'e', 'i', 'o', 'u'].includes(word[0].toLowerCase()) ? 'an' : 'a'
}

export function capitalizeWords(str: string): string {
  return str
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

export function pluralizeWord(str: string): string {
  return str.endsWith('s') ? str : `${str}s`
}

export function pluralize(
  value: number,
  unit: string,
  options?: { unitsOnly?: boolean; customPluralUnit?: string }
): string {
  const units =
    value !== 1 && options?.customPluralUnit != null
      ? options.customPluralUnit
      : `${unit}${value === 1 ? '' : 's'}`

  if (options?.unitsOnly === true) {
    return units
  }

  return `${value} ${units}`
}

export function withOrdinalSuffix(num: number): string {
  if (num === 11 || num === 12 || num === 13) {
    return `${num}th`
  }

  const lastDigit = num % 10

  switch (lastDigit) {
    case 1: {
      return `${num}st`
    }
    case 2: {
      return `${num}nd`
    }
    case 3: {
      return `${num}rd`
    }
    default: {
      return `${num}th`
    }
  }
}

export function getRandomizedAlphanumericCode(length: number): string {
  const options = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let code = ''

  for (let i = 0; i < length; i += 1) {
    const charIndex = Math.floor(Math.random() * options.length)
    code += options[charIndex]
  }

  return code
}

export function numberWithCommas(x: number): string {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function joinWithConjunction(words: string[], conjunction = 'and'): string {
  if (words.length === 0) {
    return ''
  }
  if (words.length === 1) {
    return words[0]
  }
  return `${words.slice(0, -1).join(', ')} ${conjunction} ${words.slice(-1)}`
}

export function wordWithArticle(word: string): string {
  if (word.length === 0) {
    return word
  }
  return ['a', 'e', 'i', 'o', 'u'].includes(word[0].toLowerCase()) ? `an ${word}` : `a ${word}`
}
